import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Row,
  InputGroup,
} from "reactstrap";
import Styles from "../homework/assets/Form.module.css";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import pluscircle from "../homework/assets/images/plus circle_.png";
import grp713 from "../homework/assets/images/Group 713.png";
import delete1 from "../homework/assets/images/delete.png";
import axiosInstance from "../../axiosInterceptor";
import { FaSearch } from "react-icons/fa";
import Select from "react-select";
import ActionButtons from "../../components/chat/ActionButtons";
import ToggleSwitch from "../../components/ToggleSwitch";
const Universities = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [universities, setUniversities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [countryOptions, setCountryOptions] = useState([]);
const [selectedCountry, setSelectedCountry] = useState({
  value: "Canada",
  label: "Canada",
});
  const navigator = useNavigate();

  const fetchData = async (page = 1) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        `admin/universities/getUniversityPagination`,
        {
          perPage: perPage,
          pageNo: page,
          search: searchTerm,
          country: selectedCountry?.value,
        },
      );
      const { data, totalPages } = response.data;
      setUniversities(data);
      setTotalPages(totalPages);
      setCurrentPage(page);
    } catch (error) {
      toast.error("Something went wrong. Please try again!!");
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   const delayDebounce = setTimeout(() => {
  //     fetchData(1);
  //   }, 500);

  //   return () => clearTimeout(delayDebounce);
  // }, [searchTerm]);

  // useEffect(() => {
  //   fetchData(1);
  // }, [selectedCountry]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchData(1);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm, selectedCountry]);

  const fetchCountryList = async () => {
    try {
      const response = await axiosInstance.post(
        `admin/universities/getAllCountryByUniversity`,
      );
      const countries = response.data.data;

      const options = countries.map((countryName) => ({
        value: countryName,
        label: countryName,
      }));
      setCountryOptions(options);
    } catch (error) {
      console.error("Error fetching countries:", error);
      toast.error("Something went wrong. Please try again!!");
    }
  };
  useEffect(() => {
    // fetchData();
    fetchCountryList();
  }, []);

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchData(page);
    }
  };

  const handleDelete = async (id) => {
    setDeleteItemId(id);
    setModalOpen(true);
  };

  const confirmDelete = async () => {
    try {
      const response = await axiosInstance.delete(
        `admin/universities/deleteUniversity/${deleteItemId}`,
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        fetchData();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(
        error.response.data.message ||
          "Something went wrong. Please try again!!",
      );
    } finally {
      setDeleteItemId(null);
      setModalOpen(false);
    }
  };

  return (
    <>
      <div>
        <div className="my-2">
          <div className="row mb-2">
            <div className="d-flex justify-content-between">
              <div>
                <h4 className="page-title">University List</h4>
              </div>
              <div>
                <Link to="/add-universities">
                  <Button className="action-button add-from-new">
                    <img
                      src={pluscircle}
                      alt="plus"
                      width={20}
                      className="ADD_code"
                    />
                    <span> Add </span>
                  </Button>
                </Link>
              </div>
            </div>
          </div>

          <Card>
            <CardBody>
              <Row className="Extra_padding d-flex align-items-center">
                <div className="col-md-6">
                  <InputGroup className="search_input_icon">
                    <Input
                      type="text"
                      placeholder="Search.."
                      name="searchTerm"
                      className="border_none_icon"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          fetchData(1);
                        }
                      }}
                    />
                    <div className="input-group-append">
                      <span
                        className="input-group-text wallte"
                        onClick={() => fetchData()}
                      >
                        <FaSearch />
                      </span>
                    </div>
                  </InputGroup>
                </div>

                <div className="col-md-6">
                  <Select
                    options={countryOptions}
                    value={selectedCountry}
                    onChange={(selected) => {
                      setSelectedCountry(selected);
                    }}
                    placeholder="Select Country"
                    isClearable
                  />
                </div>
              </Row>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              {loading ? (
                <div className="text-center mt-4">
                  <p>Loading...</p>
                </div>
              ) : (
                <Table
                  bordered
                  striped
                  responsive
                  className="mt-4 text-center"
                  style={{ fontSize: "0.8rem" }}
                >
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Country Name</th>
                      <th>University Name</th>
                      <th>Course</th>
                      <th>isActive</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {universities?.length > 0 ? (
                      universities.map((data, index) => {
                        const serialNumber =
                          (currentPage - 1) * perPage + index + 1;
                        return (
                          <tr key={`${index}`}>
                            <td> {serialNumber} </td>

                            <td>{data.countryName}</td>

                            <td>{data?.universityName}</td>
                            <td>
                              <div className="d-flex justify-content-center">
                                <div
                                  className={Styles.countButton1}
                                  onClick={() => {
                                    navigator(`/courses/${data?._id}`);
                                  }}
                                >
                                  {data?.courseCount || 0}
                                </div>
                              </div>
                            </td>
                            <td>
                              <FormGroup switch>
                                 <ToggleSwitch data={data} name={"isActive"} checked={data.isActive}/>
                              </FormGroup>
                            </td>

                            <td>
                              <ActionButtons
                                onEdit={() =>
                                  navigator("/add-universities", {
                                    state: data,
                                  })
                                }
                                onDelete={() => handleDelete(data._id)}
                                editIcon={grp713}
                                deleteIcon={delete1}
                              />
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No data found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              )}
              <div className="float-end">
                <Pagination>
                  <PaginationItem disabled={currentPage === 1}>
                    <PaginationLink
                      previous
                      onClick={() => handlePageClick(currentPage - 1)}
                    />
                  </PaginationItem>

                  {Array.from(
                    { length: totalPages },
                    (_, index) => index + 1,
                  ).map((page) => {
                    if (
                      page === 1 ||
                      page === totalPages ||
                      Math.abs(currentPage - page) <= 1
                    ) {
                      return (
                        <PaginationItem
                          key={page}
                          active={page === currentPage}
                        >
                          <PaginationLink onClick={() => handlePageClick(page)}>
                            {page}
                          </PaginationLink>
                        </PaginationItem>
                      );
                    }
                    if (
                      (page === currentPage - 2 || page === currentPage + 2) &&
                      totalPages > 5
                    ) {
                      return (
                        <PaginationItem key={`ellipsis-${page}`} disabled>
                          <PaginationLink>...</PaginationLink>
                        </PaginationItem>
                      );
                    }
                    return null;
                  })}
                  <PaginationItem disabled={currentPage === totalPages}>
                    <PaginationLink
                      next
                      onClick={() => handlePageClick(currentPage + 1)}
                    />
                  </PaginationItem>
                </Pagination>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
      <Modal
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        style={{ top: "33%" }}
      >
        <ModalHeader toggle={() => setModalOpen(!modalOpen)}>
          Confirm Delete
        </ModalHeader>
        <ModalBody>Are you sure you want to delete this university?</ModalBody>
        <ModalFooter>
          <div className={`${Styles.button_color}`}>
            <Button type="cancel" onClick={() => setModalOpen(!modalOpen)}>
              No
            </Button>
          </div>
          <div className={`${Styles.cancel_button} me-4`}>
            <Button
              type="cancel"
              className={`${Styles.cancel_button}`}
              onClick={confirmDelete}
            >
              Yes
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Universities;
